/**
 * @generated SignedSource<<f53c22e3eef77791d2de844babc90b66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZnSendPasswordResetEmailInput = {
  clientMutationId?: string | null | undefined;
  username: string;
};
export type Auth_PasswordReset_Mutation$variables = {
  input: ZnSendPasswordResetEmailInput;
};
export type Auth_PasswordReset_Mutation$data = {
  readonly znSendPasswordResetEmail: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type Auth_PasswordReset_Mutation = {
  response: Auth_PasswordReset_Mutation$data;
  variables: Auth_PasswordReset_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ZnSendPasswordResetEmailPayload",
    "kind": "LinkedField",
    "name": "znSendPasswordResetEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Auth_PasswordReset_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Auth_PasswordReset_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9383e03625da65b2d8861f19c81090f6",
    "id": null,
    "metadata": {},
    "name": "Auth_PasswordReset_Mutation",
    "operationKind": "mutation",
    "text": "mutation Auth_PasswordReset_Mutation(\n  $input: ZnSendPasswordResetEmailInput!\n) {\n  znSendPasswordResetEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "da64a73d077c3fd614f0e751ce95e0ad";

export default node;
